import React from "react";
import { Link } from "react-router-dom";
import { FooterLink } from "../../types";

interface FooterSectionProps {
  title: string;
  links: FooterLink[];
  handleExternalRedirect: (url: string) => void;
}

export const FooterSection: React.FC<FooterSectionProps> = ({
  title,
  links,
  handleExternalRedirect,
}) => {
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <h3 className="font-bold mb-4">{title}</h3>
      <ul className="space-y-2">
        {links.map((link) => (
          <li key={link.text}>
            {link.external ? (
              <button
                onClick={() => handleExternalRedirect(link.url)}
                className="hover:text-gray-600 dark:hover:text-gray-300"
              >
                {link.text}
              </button>
            ) : (
              <Link
                to={link.url}
                className="hover:text-gray-600 dark:hover:text-gray-300"
                onClick={handleLinkClick}
              >
                {link.text}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};